import { CatalogPlan } from '../types';

const getYearlySaving = (
    plans?: CatalogPlan[],
    discountPercentage?: number,
) => {
    if (!plans) {
        return 0;
    }

    const monthly = plans.find((plan) => plan.frequency === 'Monthly');
    const yearly = plans.find((plan) => plan.frequency === 'Yearly');

    const monthlyPrice = monthly?.subscriptionPrice ?? 0;
    const monthlyPriceYearlyCost = monthlyPrice * 12;

    const yearlyPrice = yearly?.subscriptionPrice ?? 0;
    const yearlyPriceWithDiscount = discountPercentage
        ? yearlyPrice * (1 - discountPercentage / 100)
        : yearlyPrice;

    const yearlySaving = Math.round(
        (1 - yearlyPriceWithDiscount / monthlyPriceYearlyCost) * 100,
    );

    return yearlySaving;
};

export default getYearlySaving;
